import React from "react";
import { Link as MuiLink } from "@mui/material";

/** Keyboard-only skip link; target must match `id` on the main landmark. */
const SkipToMain: React.FC = () => (
  <MuiLink
    href="#main-content"
    component="a"
    sx={{
      position: "absolute",
      left: 16,
      top: 12,
      zIndex: 2000,
      px: 2,
      py: 1,
      borderRadius: 2,
      bgcolor: "primary.main",
      color: "primary.contrastText",
      fontWeight: 700,
      textDecoration: "none",
      transform: "translateY(-160%)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      boxShadow: 3,
      "&:focus": {
        transform: "translateY(0)",
        outline: "3px solid",
        outlineColor: "secondary.light",
        outlineOffset: 2,
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",
      },
    }}
  >
    Skip to main content
  </MuiLink>
);

export default SkipToMain;
